import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { fmtDateTime, label } from "@/lib/format";
import { PageHeader, Loading } from "@/components/Kpi";
import { DataTable } from "@/components/DataTable";

export default function AuditLog() {
  const { data, isLoading } = useQuery({ queryKey: ["audit"], queryFn: () => api.get("/audit-logs?limit=500").then((r) => r.data) });
  const { data: projects = [] } = useQuery({ queryKey: ["projects"], queryFn: () => api.get("/projects").then((r) => r.data) });
  if (isLoading) return <Loading />;
  const cols = [
    { key: "ts", label: "Data/ora", render: (r) => fmtDateTime(r.ts) }, { key: "user_email", label: "Utente" }, { key: "action", label: "Azione", render: (r) => <span className="font-medium">{label(r.action)}</span> },
    { key: "entity", label: "Entità", render: (r) => label(r.entity) }, { key: "project_id", label: "Operazione", render: (r) => projects.find((p) => p.id === r.project_id)?.code || "—" },
    { key: "reason", label: "Motivazione" }, { key: "after", label: "Dettaglio", render: (r) => <span className="text-xs text-slate-500 block max-w-md truncate" title={JSON.stringify(r.after || r.before)}>{JSON.stringify(r.after || r.before || {}).slice(0, 120)}</span> },
  ];
  return (
    <div>
      <PageHeader title="Audit log" subtitle="Registro immutabile: approvazioni, SAL, override, cancellazioni, riaperture, aliquote e finanziamenti" />
      <DataTable columns={cols} rows={data || []} testId="audit-table" pageSize={50} />
    </div>
  );
}
